import React from "react";

import { userPermissionSet } from "helpers";
import { useUserSearchQuery } from "queries";

import { userResultItem } from "../resultItems";

import { ReactComponent as UserIcon } from "static/images/user.svg";

const userSection = () => {
	return {
		name: "users",
		title: "User",
		useSearchQuery: useUserSearchQuery,
		renderItem: userResultItem,
		getIcon: () => <UserIcon fill="#15acc5" />,
		getLink: ({ id }) => `/system-setup/users/${id}`,
		requiredPermissions: userPermissionSet,
	};
};

export default userSection;
